"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedpackagelocation = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedpackagelocation` : '') + (description ? ` desc-brandedpackagelocation` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedpackagelocation"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedpackagelocation"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.8 7.8a4 4 0 0 1 4-4h44a4 4 0 0 1 4 4v44a4 4 0 0 1-4 4h-44a4 4 0 0 1-4-4v-44Z",
    fill: "#EDBC7C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.8 7.51V51.8c0 .5 0 1.16.66 2.2 10.64-6.8 17.82-12.03 25.81-19.8C42.1 22.7 52.5 10 54.66 5 53.5 4 53 3.8 51.8 3.8H7.53A3.72 3.72 0 0 0 3.8 7.51Z",
    fill: "#F9D29F"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.8 21.8v-18h16v16.88l-3.76-4.5-3.77 4.5-3.76-4.5-4.71 5.62Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.8 40.77c0-4.72-2.13-12.97-11.8-12.97-9.49 0-12.2 7.86-12.2 12.97 0 7.67 8.52 15.92 12.2 21.03 3.93-4.85 11.8-13.76 11.8-21.03Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.8 39.8a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    fill: "#DAFCFE"
  }));
};
var _default = exports.default = brandedpackagelocation;